import { CSP_TYPES } from '@Constants/Shipment';
import { AppDispatch } from '@Store';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import dayjs from 'dayjs';
import { AramexUserInformationType } from '@Reducers/AdminShipment/Type';

export const initAramexInformation: any = {
  _id: '',
  accountNo: '',
  pin: '',
  name: '',
  csp: CSP_TYPES.aramex.value,
  api_key: '',
  secret_key: '',
  isDefault: false,
  _system: [],
  isActive: false,
  createdAt: '',
  updatedAt: '',
  __v: 0,
};

interface DropdownOptionType {
  value: string;
  display: string;
}

// Enums for productType and paymentType
export enum ProductTypeEnum {
  PPX = 'PPX',
  DPX = 'DPX',
  GPX = 'GPX',
  PLX = 'PLX',
  PDX = 'PDX',
}

export enum PaymentTypeEnum {
  P = 'P',
  C = 'C',
  Three = '3',
}

export const onForward = async ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
  setLoading,
}: {
  values: AramexUserInformationType;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  try {
    setLoading(true);

    const body = { ...JSON.parse(JSON.stringify(values)) };
    body.csp = 'aramex';

    for (const key in body) {
      if (body[key]) {
        if (key === 'accountNo') {
          if (Array.isArray(body[key])) {
            body[key] = body[key][0]?.value?.split('-')?.[0] || '';
          } else if (typeof body[key] === 'object' && body[key]?.value) {
            body[key] = body[key].value.split('-')?.[0] || '';
          } else if (typeof body[key] === 'string') {
            body[key] = body[key].split('-')?.[0];
          }
        }
        if (key === 'invoiceDate') {
          body[key] = dayjs(values?.invoiceDate).format('MM/DD/YYYY');
        }
        if (key === 'productType' && Array.isArray(body[key])) {
          body[key] = body[key].join(',');
        }
        if (key === 'paymentType' && Array.isArray(body[key])) {
          body[key] = body[key].join(',');
        }
      }
    }

    await dispatch(
      postFedExDetails({
        shipmentNumber: `${shipmentNumber}`,
        body,
        date: values?.invoiceDate ? dayjs(values?.invoiceDate).format() : '',
        nextFunc,
      }),
    );
  } catch (error) {
    console.error('Error in forwarding Aramex details:', error);
  } finally {
    setLoading(false);
  }
};

// String literals for productType and paymentType
export type ProductType = 'PPX' | 'DPX' | 'GPX' | 'PLX' | 'PDX';
export type PaymentType = 'P' | 'C' | '3';

export const ProductTypeOptions: DropdownOptionType[] = [
  { value: ProductTypeEnum.PPX, display: 'PPX' },
  { value: ProductTypeEnum.DPX, display: 'DPX' },
  { value: ProductTypeEnum.GPX, display: 'GPX' },
  { value: ProductTypeEnum.PLX, display: 'PLX' },
  { value: ProductTypeEnum.PDX, display: 'PDX' },
];

export const PaymentTypeOptions: DropdownOptionType[] = [
  // { value: PaymentTypeEnum.Three, display: 'Third Party' },
  { value: PaymentTypeEnum.C, display: 'Consignee' },
  { value: PaymentTypeEnum.P, display: 'Prepaid' },
];
